import React from 'react';
import classNames from 'classnames';

const getBoundingRect = selector =>
  document.querySelector(selector)?.getBoundingClientRect();

class StickySidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = { sticky: false };
    this.ticking = false;
    this.navbarHeight = getBoundingRect('nav.navbar')?.height || 0;
    this.handleScroll = this.handleScroll.bind(this);
    this.toggleStickBar = this.toggleStickBar.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll, false);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll, false);
  }

  toggleStickBar(scrollY) {
    let notificationBarHeight = 0;
    const notificationBar = document.querySelector('.NotificationContainer');
    if (notificationBar) {
      notificationBarHeight = notificationBar?.getBoundingClientRect()?.height;
    }

    this.setState({
      sticky: scrollY >= this.navbarHeight + notificationBarHeight,
    });
  }

  handleScroll() {
    if (this.props.disable) return;

    const scrollY = window.scrollY || window.pageYOffset || 0;

    if (!this.ticking) {
      requestAnimationFrame(() => {
        this.toggleStickBar(Math.floor(scrollY));
        this.ticking = false;
      });
    }
    this.ticking = true;
  }

  render() {
    const { children } = this.props;
    const className = classNames({
      sticky: this.state.sticky,
      [this.props.className]: !!this.props.className,
    });

    return <div className={className} children={children} />;
  }
}

export default StickySidebar;
